<i18n>
{
	"en": {
		"type": "Trip Type",
		"selectType": "Select trip type"
	},
	"no": {
		"type": "Type Tur",
		"selectType": "Velg turtype"
	}
}
</i18n>

<template>
	<t-form-group :title="$t('type')" rowGap="5px">
		<t-select
			:selectedItem="selectedItem.id"
			:items="tripTypes"
			:disabled="disabled"
			showPopoverOnFocus
			@select="$emit('select', $event)"
		>
			<template #displayedValue>
				<div class="list-item">
					<t-timpex-icon
						:icon="selectedItem.id ? getTripTypeIcon(selectedItem.internalCode) : 'flows'"
						type="bp"
						:color="selectedItem.id ? 'neutral' : 'orange'"
					/>
					<div>{{ selectedItem.id ? selectedItem.description : $t('selectType') }}</div>
				</div>
			</template>
			<template #optionItemValue="{ item }">
				<div class="list-item">
					<t-timpex-icon
						:icon="getTripTypeIcon(item.internalCode)"
						type="bp"
						color="neutral"
					/>
					<div>{{ item.description }}</div>
				</div>
			</template>
		</t-select>
	</t-form-group>
</template>

<script>
import { tripTypeIcon } from '@/core';
import { mapActions, mapGetters } from './store/tripTypes.store';

export default {
	name: 'TripTypesFormInput',
	props: { selectedItem: Object },
	computed: {
		...mapGetters({ tripTypes: 'getTripTypesWithInternalCode' }),
		disabled() {
			return !this.tripTypes || this.tripTypes.length === 0;
		},
	},
	mounted() {
		this.getTripTypes();
	},
	methods: {
		...mapActions(['getTripTypes']),
		getTripTypeIcon(iconId) {
			return tripTypeIcon(iconId);
		},
	}
};
</script>

<style lang="scss" scoped>
.list-item {
	display: flex;
	align-items: center;
	justify-content: flex-start;

	> div {
		margin-left: 10px;
	}
}
</style>


